import { getSettings } from './api';

// ✅ Declare the variable first with empty string
let WA_NUMBER = '';

// Load from settings on module init
getSettings()
  .then(data => { if (data?.wa_number) WA_NUMBER = data.wa_number; })
  .catch(() => {});

/* ── Helper to always get the latest number ── */
function getWaNumber() {
  return WA_NUMBER;
}

export function buildOrderMessage(cartItems, customer, promoCode = '', discount = 0) {
  const lines = cartItems.map(
    (i) => `• ${i.brand} — ${i.name}${i.sku ? ` [${i.sku}]` : ''} × ${i.qty}  ₹${(i.price * i.qty).toLocaleString('en-IN')}`
  );
  const subtotal = cartItems.reduce((s, i) => s + i.price * i.qty, 0);
  const total    = subtotal - (discount || 0);

  const msg = [
    '🛍 *New Order — Aurora Luxury India*',
    '',
    '*Items:*',
    ...lines,
    '',
    promoCode ? `Promo Code: ${promoCode} (−₹${discount.toLocaleString('en-IN')})` : null,
    `*Total: ₹${total.toLocaleString('en-IN')}*`,
    '',
    '*Customer Details:*',
    `Name: ${customer.name}`,
    `Phone: ${customer.phone}`,
    customer.email   ? `Email: ${customer.email}`     : null,
    customer.address ? `Address: ${customer.address}` : null,
    customer.notes   ? `Notes: ${customer.notes}`     : null,
    '',
    `Order Ref: ALI-${Date.now()}`,
  ]
    .filter((l) => l !== null)
    .join('\n');

  return `https://wa.me/${getWaNumber()}?text=${encodeURIComponent(msg)}`;
}

export function buildEnquiryMessage(product) {
  const msg = [
    '🔍 *Product Enquiry — Aurora Luxury India*',
    '',
    `Brand: ${product.brand}`,
    `Name: ${product.name}`,
    `Price: ₹${product.price.toLocaleString('en-IN')}`,
    product.sku        ? `SKU: ${product.sku}`                  : `Product ID: #${product.id}`,
    product.condition  ? `Condition: ${product.condition}`      : null,
    product.serial_ref ? `Serial / Ref: ${product.serial_ref}`  : null,
    '',
    'I would like more information about this piece.',
  ]
    .filter(Boolean)
    .join('\n');

  return `https://wa.me/${getWaNumber()}?text=${encodeURIComponent(msg)}`;
}

export function buildRequestMessage(form) {
  const msg = [
    '📦 *Piece Request — Aurora Luxury India*',
    '',
    `Name: ${form.name}`,
    `Phone: ${form.phone}`,
    form.brand  ? `Brand: ${form.brand}`   : null,
    form.model  ? `Model: ${form.model}`   : null,
    form.colour ? `Colour: ${form.colour}` : null,
    form.budget ? `Budget: ${form.budget}` : null,
  ]
    .filter(Boolean)
    .join('\n');

  return `https://wa.me/${getWaNumber()}?text=${encodeURIComponent(msg)}`;
}